module.exports = __webpack_public_path__ + "static/media/refral2.5636bc3a.svg";